const hideIfCartEmpty = class extends HTMLElement {
  constructor () {
    super()
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      this.classList.toggle('hide', cartData.item_count === 0)
    })
  }
}

if (typeof window.customElements.get('hide-if-cart-empty') === 'undefined') {
  window.customElements.define('hide-if-cart-empty', hideIfCartEmpty)
}

const showIfCartEmpty = class extends HTMLElement {
  constructor () {
    super()
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      this.classList.toggle('hide', cartData.item_count !== 0)
    })
  }
}

if (typeof window.customElements.get('show-if-cart-empty') === 'undefined') {
  window.customElements.define('show-if-cart-empty', showIfCartEmpty)
}

const showIfCartOver = class extends HTMLElement {
  constructor () {
    super()
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      this.classList.toggle('hide', cartData.total_price < (parseInt(this.getAttribute('data-threshold'), 10) * 100))
    })
  }
}

if (typeof window.customElements.get('show-if-cart-over') === 'undefined') {
  window.customElements.define('show-if-cart-over', showIfCartOver)
}

const showIfCartDiscounts = class extends HTMLElement {
  constructor () {
    super()
    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      this.classList.toggle('hide', (cartData.total_discount !== null && cartData.total_discount === 0))
    })
  }
}

if (typeof window.customElements.get('show-if-cart-discounts') === 'undefined') {
  window.customElements.define('show-if-cart-discounts', showIfCartDiscounts)
}
